import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'fgb-auction-wallet-details-page',
  templateUrl: './auction-wallet-details-page.component.html',
  styleUrls: ['./auction-wallet-details-page.component.scss'],
})
export class AuctionWalletDetailsPageComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}
  id: number;
  ngOnInit() {
    this.id = +(this.route.snapshot.paramMap.get('id') || 0);
  }
}
